import { getUnixTs } from "@bridgesplit/utils";

import { Ledger, LedgerExpanded } from "../types";

export function ledgerInterestOutstanding(ledger: LedgerExpanded | Ledger, currentTime: number) {
    return calculateInterestOutstanding(
        ledger.interestOutstanding,
        ledger.interestPerSecond,
        currentTime,
        ledger.lastInterestUpdatedTime
    );
}
export function calculateInterestOutstanding(
    prevInterestOutstanding: number,
    interestPerSecond: number,
    currentTimestamp: number,
    lastInterestUpdate: number
) {
    const accrualTime = currentTimestamp - lastInterestUpdate;
    const newInterestAccrued = accrualTime * interestPerSecond;

    const totalInterestAccrued = newInterestAccrued + prevInterestOutstanding;

    return totalInterestAccrued;
}

/**
 * Previously, loan duration used an incorrect constant for YEAR in seconds,
 * which resulted in a minor difference for calculating ledgers from a schedule
 * @returns the seconds in a year used for a loan's APY calc
 */

export function summarizeLedgerAccount(ledgerAccount: LedgerExpanded | Ledger | undefined, now = getUnixTs()) {
    const endTime = ledgerAccount?.endTime ?? 0;

    // handle overpaid principal
    const principalDue = ledgerAccount ? Math.max(ledgerAccount.principalDue, ledgerAccount.principalRepaid) : 0;
    const principalPaid = ledgerAccount?.principalRepaid ?? 0;
    const principalOutstanding = Math.max(principalDue - principalPaid, 0);

    const interestOutstanding = ledgerAccount ? ledgerInterestOutstanding(ledgerAccount, now) : 0;

    const apy = ledgerAccount?.apy ?? 0;
    const totalOutstanding = principalOutstanding + interestOutstanding;

    return {
        principalDue,
        principalPaid,
        endTime,
        apy,
        totalOutstanding,
        principalOutstanding,
        interestOutstanding
    };
}
